import classNames from "classnames/bind";
import styles from "./ConfigValue.module.css";
import { Button, Col, Loading, Row, Toast } from "../../../../../components";
import ListConfig from "../../ListConfig";
import { useEffect } from "react";
import { useState } from "react";
import axiosClient from "../../../../../services/axiosClient";
import { listInfoAiConfig } from "../../config";
import { aiConfigService } from "../../../../../services/api/aiConfigService";
import { configDefault } from "../../../../../services/api/configDefault";
import ModalConfirm from "../../ModalConfirm";

const cx = classNames.bind(styles);

function ConfigValue({ label, codeService, config, handleRefresh }) {
    const [paramConfig, setParamConfig] = useState(listInfoAiConfig);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [token, setToken] = useState(false);
    const onChangeParam = (key, value) => {
        const param = paramConfig.map((item) => {
            if (item.id === key) {
                return {
                    ...item,
                    value: value,
                }
            } else if (item.id === 'time_frame') {
                if (key === "TIME_START_FRAME") {
                    return {
                        ...item,
                        value: [value, item.value[1]]
                    }
                } else if (key === 'TIME_END_FRAME') {
                    return {
                        ...item,
                        value: [item.value[0], value]
                    }
                } else {
                    return item;
                }
            } else {
                return item
            }
        })
        setParamConfig(param)
    }

    // lấy danh sách loại cấu hình
    const getListParams = async (code) => {
        try {
            const res = await axiosClient.get(
                `aiServiceParam/get-list-ai-service-param/?service_code=${code}`
            );
            return res;
        } catch (error) {
            // Toast.open('Bạn không có quyền cấu hình AI', 'danger')
        }
    };

    // lấy danh sách mức độ của loại cấu hình
    const getListLevelParams = async (listParam) => {
        try {
            const res = await aiConfigService.postListValueParam(listParam);
            return res;
        } catch (error) {
            // Toast.open('Bạn không có quyền cấu hình AI', 'danger')
        }
    };

    const mergeDataDefault = async (params, data) => {
        let dataFormatted = [...params];
        const listParamCode = dataFormatted?.map((item) => {
            return {
                ai_param_code: item.AI_PARAM_CODE
            }
        })
        let levels = [];
        levels = await getListLevelParams(listParamCode);
        dataFormatted.forEach((item, index) => {
            const levelParam = levels.find((it) => it[0].AI_PARAM_CODE === item.AI_PARAM_CODE);
            dataFormatted[index].LEVEL = levelParam ? levelParam : [];
        })
        if (data.length >= 2) {
            for (let i = 0; i < data.length; i++) {
                for (let j = 0; j < dataFormatted.length; j++) {
                    if (
                        data[i].AI_PARAM_CODE === dataFormatted[j].AI_PARAM_CODE
                    ) {
                        dataFormatted[j].DEFAULT_LEVEL_CODE = data[i].AI_PARAM_LEVEL_CODE;
                        dataFormatted[j].DEFAULT_LEVEL_NAME = data[i].PARAM_LEVEL;
                    }
                }
            }
        } else {
            for (let i = 0; i < dataFormatted.length; i++) {
                let code = dataFormatted[i].AI_PARAM_CODE;
                let minDuration =
                    label === "phát hiện chuyển động" ? "Cao" : "Thấp";
                let sensitive =
                    label === "phát hiện chuyển động" ? "Thấp" : "Trung bình";
                let minObjectSize =
                    label === "phát hiện chuyển động" ? "Lớn" : "Trung bình";
                let illuminationThresh =
                    label === "phát hiện chuyển động" ? "Trung bình" : "Thấp";
                let maxDissapear = "Trung bình";
                let carDetConfidenceThreshold = "Thấp";
                let direction = "Từ trên xuống";
                switch (dataFormatted[i].PARAM) {
                    case "min_duration":
                        let levelDefaultMd = dataFormatted[i].LEVEL.find(
                            (item) =>
                                item.PARAM_LEVEL === minDuration &&
                                item.AI_PARAM_CODE === code
                        );
                        dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultMd.CODE;
                        dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultMd.PARAM_LEVEL;
                        break;
                    case "illumination_thresh":
                        let levelDefaultIt = dataFormatted[i].LEVEL.find(
                            (item) =>
                                item.PARAM_LEVEL === illuminationThresh &&
                                item.AI_PARAM_CODE === code
                        );
                        dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultIt.CODE;
                        dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultIt.PARAM_LEVEL;
                        break;
                    case "confidence_threshold":
                        let levelDefaultCt = dataFormatted[i].LEVEL.find(
                            (item) =>
                                item.PARAM_LEVEL === "Cao" &&
                                item.AI_PARAM_CODE === code
                        );
                        dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultCt.CODE;
                        dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultCt.PARAM_LEVEL;
                        break;
                    case "sensitive":
                        let levelDefaultS = dataFormatted[i].LEVEL.find(
                            (item) =>
                                item.PARAM_LEVEL === sensitive &&
                                item.AI_PARAM_CODE === code
                        );
                        dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultS.CODE;
                        dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultS.PARAM_LEVEL;
                        break;
                    case "min_object_size":
                        let levelDefaultMos = dataFormatted[i].LEVEL.find(
                            (item) =>
                                item.PARAM_LEVEL === minObjectSize &&
                                item.AI_PARAM_CODE === code
                        );
                        dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultMos?.CODE;
                        dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultMos?.PARAM_LEVEL;
                        break;
                    case "max_dissapear":
                        let levelDefaultMdr = dataFormatted[i].LEVEL.find(
                            (item) =>
                                item.PARAM_LEVEL === maxDissapear &&
                                item.AI_PARAM_CODE === code
                        );
                        dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultMdr.CODE;
                        dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultMdr.PARAM_LEVEL;
                        break;
                    case "car_det_confidence_threshold":
                        let levelDefaultCdct = dataFormatted[i].LEVEL.find(
                            (item) =>
                                item.PARAM_LEVEL === carDetConfidenceThreshold &&
                                item.AI_PARAM_CODE === code
                        );
                        dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultCdct.CODE;
                        dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultCdct.PARAM_LEVEL;
                        break;
                    case "direction":
                        let levelDefaultD = dataFormatted[i].LEVEL.find(
                            (item) =>
                                item.PARAM_LEVEL === direction &&
                                item.AI_PARAM_CODE === code
                        );
                        dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultD.CODE;
                        dataFormatted[i].DEFAULT_LEVEL_NAME = levelDefaultD.PARAM_LEVEL;
                        break;
                    default:
                        let levelDefaultDf = dataFormatted[i].LEVEL.find(
                            (item) =>
                                item.PARAM_LEVEL === "Trung bình" &&
                                item.AI_PARAM_CODE === code
                        );
                        dataFormatted[i].DEFAULT_LEVEL_CODE = levelDefaultDf?.CODE;
                        dataFormatted[i].DEFAULT_LEVEL_NAME = "Trung bình";
                        break;
                }
            }
        }
        return dataFormatted;
    };

    useEffect(() => {
        const getDataDefault = async () => {
            setLoading(true)
            try {
                const param = await getListParams(codeService);
                const formatData = await mergeDataDefault(param, []);
                const listParam = formatData?.map((item) => {
                    const valueConfig = config.find((i) => (i?.KEY?.toLowerCase() === item?.PARAM && (i?.TYPE === 'AI' || i?.TYPE === codeService)));
                    switch (item?.PARAM) {
                        case 'alarm':
                            return {
                                key: 'INPUT',
                                title: item?.DESCRIBE || '',
                                value: Number(valueConfig?.VALUE || 1),
                                id: item?.PARAM || 'empty',
                                code: valueConfig?.CODE || 1,
                                listChild: item?.LEVEL?.map((it) => {
                                    return {
                                        label: it?.PARAM_LEVEL,
                                        value: it?.CODE
                                    }
                                }) || [],
                                type: "range",
                                name: "vol",
                                step: 0.5,
                                min: "-20",
                                max: "150",
                                showValue: true,
                                styles: { width: '100%' }
                            }
                        case 'distance':
                            return <></>
                        default:
                            return {
                                key: 'SELECT_BOX',
                                title: item?.DESCRIBE || '',
                                value: Number(valueConfig?.VALUE || 1),
                                id: item?.PARAM || 'empty',
                                code: valueConfig?.CODE || 1,
                                listChild: item?.LEVEL?.map((it) => {
                                    return {
                                        label: it?.PARAM_LEVEL,
                                        value: it?.CODE
                                    }
                                }) || []
                            }
                    }
                })
                const listOtherParam = listInfoAiConfig.map((item) => {
                    if (item.id !== 'time_frame') {
                        const valueConfig = config.find((i) => (i?.KEY?.toLowerCase() === item?.id && (i?.TYPE === 'AI' || i?.TYPE === codeService)));
                        return {
                            ...item,
                            code: valueConfig?.CODE || 1,
                            value: item.key === "SWITCH" ? (valueConfig?.VALUE === '1' ? true : false) : valueConfig?.VALUE
                        }
                    } else {
                        const timeStartActive = config.find((i) => (i?.KEY === "TIME_START_ACTIVE" && (i?.TYPE === 'AI' || i?.TYPE === codeService)));
                        const timeEndActive = config.find((i) => (i?.KEY === "TIME_END_ACTIVE" && (i?.TYPE === 'AI' || i?.TYPE === codeService)));
                        return {
                            ...item,
                            code: [timeStartActive?.CODE || 1, timeEndActive?.CODE || 1],
                            value: [timeStartActive?.VALUE || "00:00", timeEndActive?.VALUE || '00:00']
                        }
                    }
                })
                const paramOfService = listOtherParam?.concat(listParam);
                // Tạm thời ẩn đi các chức năng khác với cảnh báo cháy
                if (label === "cảnh báo cháy") {
                    setParamConfig(paramOfService?.filter(item => item?.id !== 'time_keeping_event_default' && item?.id !== "time_frame"));
                } else {
                    setParamConfig(paramOfService);
                }
                setLoading(false)
            } catch (error) {
                // // console.log(error);
                setLoading(false)
                Toast.open("Bạn không có quyền cấu hình AI", "danger");
            }
        };
        if (config && config.length > 0) {
            getDataDefault();
        }
        // eslint-disable-next-line
    }, [codeService, config]);

    // áp dụng tất cả và chỉ áp dụng cho các cam mới hiện đang giống nhau 
    const handleApplyAll = async () => {
        setLoading(true)
        try {
            let formData = [];
            paramConfig.forEach((item) => {
                switch (item?.id) {
                    case 'time_frame':
                        const timeStart = {
                            code: item.code[0] || 20,
                            key: "TIME_START_ACTIVE",
                            value: item.value[0] || "00:00"
                        }
                        const timeEnd = {
                            code: item.code[1] || 20,
                            key: "TIME_END_ACTIVE",
                            value: item.value[1] || "00:00"
                        }
                        formData.push(timeStart);
                        formData.push(timeEnd);
                        break;
                    case 'alarm':
                        const alarm = {
                            code: item.code,
                            key: item.id.toUpperCase(),
                            value: item.value,
                        }
                        formData.push(alarm)
                        break;
                    default:
                        const param = {
                            code: item.code,
                            key: item.id.toUpperCase(),
                            value: item.key === 'SWITCH' ? (item.value ? 1 : 0) : item.value,
                            ai_param_level_code: (item.key === 'SWITCH' || item.key === "TIME_SAVE") ? null : item.value
                        }
                        formData.push(param)
                        break;
                }
            })
            const res = await configDefault.putChangeSystemDefaultConfig(formData, 'all_cam')
            setLoading(false)
            if (res.token.length > 0) {
                setShowModal(res.result)
                setToken(res.token)
            } else {
                Toast.open(`Thiết lập mặc định thành công`, "success")
            }
        } catch (error) {
            setLoading(false)
            Toast.open('Thiết lập mặc định không thành công', 'danger')
        }
    }

    const handleAppForNewCam = async () => {
        setLoading(true)
        try {
            let formData = [];
            paramConfig.forEach((item) => {
                switch (item?.id) {
                    case 'time_frame':
                        const timeStart = {
                            code: item.code[0] || 20,
                            key: "TIME_START_ACTIVE",
                            value: item.value[0] || "00:00"
                        }
                        const timeEnd = {
                            code: item.code[1] || 20,
                            key: "TIME_END_ACTIVE",
                            value: item.value[1] || "00:00"
                        }
                        formData.push(timeStart);
                        formData.push(timeEnd);
                        break;
                    case 'alarm':
                        const alarm = {
                            code: item.code,
                            key: item.id.toUpperCase(),
                            value: item.value,
                        }
                        formData.push(alarm)
                        break;
                    default:
                        const param = {
                            code: item.code,
                            key: item.id.toUpperCase(),
                            value: item.key === 'SWITCH' ? (item.value ? 1 : 0) : item.value,
                            ai_param_level_code: (item.key === 'SWITCH' || item.key === "TIME_SAVE") ? null : item.value
                        }
                        formData.push(param)
                        break;
                }
            })
            const res = await configDefault.putChangeSystemDefaultConfig(formData)
            setLoading(false)
            if (res.token.length > 0) {
                setShowModal(res.result)
                setToken(res.token)
            } else {
                Toast.open(`Thiết lập mặc định thành công`, "success")
            }
        } catch (error) {
            // // console.log(error);
            setLoading(false)
            Toast.open('Thiết lập mặc định không thành công', 'danger')
        }
    }

    const handleCancel = () => {
        handleRefresh()
    }
    return (
        <>
            {loading && <div className={cx('modal-load')}>
                <Loading />
            </div>}
            <Row gap={[0, 16]}>
                <Col span={12}>
                    <ListConfig listParamConfig={paramConfig} onChangeParam={onChangeParam} />
                </Col>
            </Row>
            <Row gap={[0, 16]}>
                <Col span={12}>
                    <div className={cx('footer')}>
                        <Button title={'Hủy bỏ'} className={cx('btn', 'cancel')} onClick={handleCancel} />
                        <Button title={'Áp dụng tất cả'} className={cx('btn')} onClick={handleApplyAll} />
                        <Button title={'Áp dụng mới'} className={cx('btn')} onClick={handleAppForNewCam} />
                    </div>
                </Col>
            </Row>
            <ModalConfirm isShow={showModal} onClose={() => setShowModal(false)} token={token} />
        </>
    )
}

export default ConfigValue;